/**
 * Dial blocks (BACKLOG C-2): the booking rules the backend enforces, mirrored
 * so the caller's week can be drawn and obvious refusals avoided. The backend
 * (`common/dialblocks`) stays the authority for every rule.
 */

/** Business clock: every block rule is in Eastern Time. */
export const DIAL_BLOCK_ET_ZONE = "America/New_York";

/** A block always lasts 3 h 30 min from its start. */
export const DIAL_BLOCK_LENGTH_MINUTES = 210;
